import ViewManager from '../managers/view';
import {isNotNullOrEmptyArray, isNotNullOrWhitespace} from '../util/empty-helpers';

export function getTravelinkBasket(_callback) {
    let headers = new Headers();
    headers.set('Content-Type', 'application/json');
    return fetch('/assets/json/basket.json', {
      method: 'get',
      headers: headers
    })
    .then((response) => response.json())
    .then((responseJson) => {
      sessionStorage.setItem("basket", JSON.stringify(responseJson));
      _callback(responseJson);
    });
}

export function initFlights(flight) {
  if (flight[0] !== null && flight[1] !== null) {
    let inserts = document.querySelectorAll('[data-insert]');
    let indexes = {};
    for (let i = 0; i < inserts.length; i++) {
      indexes[inserts[i].dataset.insert] = i;
    }
    let control = document.querySelector('[data-basket-element="flights"]');
    control.classList.remove('hidden');

    // Outbound Flight
    inserts[indexes.OutboundDepartureFlightName].innerHTML = flight[0].AirportNameFrom + ' (' + flight[0].AirportCodeFrom + ')';
    inserts[indexes.OutboundArrivalFlightName].innerHTML = flight[0].AirportNameTo + ' (' + flight[0].AirportCodeTo + ')';
    inserts[indexes.OutboundDepartureFlightTime].innerHTML = moment(flight[0].DepartureDateTime).format('HH:mm ddd Do MMM');
    inserts[indexes.OutboundArrivalFlightTime].innerHTML = moment(flight[0].ArrivalDateTime).format('HH:mm ddd Do MMM');
    inserts[indexes.OutboundFlightProvidor].innerHTML = flight[0].AirlineName;
    inserts[indexes.OutboundFlightImage].src = flight[0].AirlineLogoUrl || '';

    if (flight[0].LuggageAllowance) {
      inserts[indexes.OutboundDepartureFlightLuggage].innerHTML = `${flight[0].TotalNumberOfAvailableBags} * ${flight[0].LuggageAllowance}kg`;
      inserts[indexes.OutboundDepartureFlightLuggage].parentNode.classList.remove('hidden');
    }

    if (isNotNullOrEmptyArray(flight[0].AirportCodeVias)) {
      let control = document.querySelector('[data-basket-element="OutboundChangeover"]');
      let controlBox = control.querySelector('.hint-inner');
      if (flight[0].Vias) {
        controlBox.innerHTML = null;
        flight[0].Vias.map((item,i) =>{
          let wrap = document.createElement('div');
          wrap.setAttribute('class', 'wrap');

          let spanName = document.createElement('span');
          spanName.setAttribute('data-insert', 'OutboundChangeover');
          spanName.innerHTML = 'Change at ' + item.AirportName + ' Airport';
          wrap.appendChild(spanName);

          if ( item.HourWait !== undefined && item.MinuteWait !== undefined) {
            let spanTime = document.createElement('span');
            spanTime.setAttribute('data-insert', 'OutboundChangeoverTime');
            let hour = item.HourWait ? item.HourWait + " hour" + (item.HourWait > 1 ? "s" : "") + " " : "";
            let minute = item.MinuteWait ? item.MinuteWait + " minute" + (item.MinuteWait > 1 ? "s" : "") + " " : "";
            spanTime.innerHTML = hour + minute + " wait";
            wrap.appendChild(spanTime);
          }

          controlBox.appendChild(wrap);
        })
      } else {
        let via = flight[0].AirportCodeVias[0].AirportNameVia || flight[0].AirportNameVia;
        inserts[indexes.OutboundChangeover].innerHTML = 'Change at ' + via + ' Airport';
      }
      control.classList.remove('hidden');
    } else {
      let control = document.querySelector('[data-basket-element="OutboundChangeover"]');
      control.classList.add('hidden');
    }

    // Inbound Flight
    inserts[indexes.InboundDepartureFlightName].innerHTML = flight[1].AirportNameFrom + ' (' + flight[1].AirportCodeFrom + ')';
    inserts[indexes.InboundArrivalFlightName].innerHTML = flight[1].AirportNameTo + ' (' + flight[1].AirportCodeTo + ')';
    inserts[indexes.InboundDepartureFlightTime].innerHTML = moment(flight[1].DepartureDateTime).format('HH:mm ddd Do MMM');
    inserts[indexes.InboundArrivalFlightTime].innerHTML = moment(flight[1].ArrivalDateTime).format('HH:mm ddd Do MMM');
    inserts[indexes.InboundFlightProvidor].innerHTML = flight[1].AirlineName;
    inserts[indexes.InboundFlightImage].src = flight[1].AirlineLogoUrl || '';

    if (flight[1].LuggageAllowance) {
      inserts[indexes.InboundArrivalFlightLuggage].innerHTML = `${flight[1].TotalNumberOfAvailableBags} * ${flight[1].LuggageAllowance}kg`;
      inserts[indexes.InboundArrivalFlightLuggage].parentNode.classList.remove('hidden');
    }

    if (isNotNullOrEmptyArray(flight[1].AirportCodeVias)) {
      let control = document.querySelector('[data-basket-element="InboundChangeover"]');
      let controlBox = control.querySelector('.hint-inner');
      if (flight[1].Vias) {
        controlBox.innerHTML = null;
        flight[1].Vias.map((item,i) =>{
          let wrap = document.createElement('div');
          wrap.setAttribute('class', 'wrap');

          let spanName = document.createElement('span');
          spanName.setAttribute('data-insert', 'InboundChangeover');
          spanName.innerHTML = 'Change at ' + item.AirportName + ' Airport';
          wrap.appendChild(spanName);

          if ( item.HourWait !== undefined && item.MinuteWait !== undefined) {
            let spanTime = document.createElement('span');
            spanTime.setAttribute('data-insert', 'InboundChangeoverTime');
            let hour = item.HourWait ? item.HourWait + " hour" + (item.HourWait > 1 ? "s" : "") + " " : "";
            let minute = item.MinuteWait ? item.MinuteWait + " minute" + (item.MinuteWait > 1 ? "s" : "") + " " : "";
            spanTime.innerHTML = hour + minute + " wait";
            wrap.appendChild(spanTime);
          }

          controlBox.appendChild(wrap);
        })
      } else {
        let via = flight[1].AirportCodeVias[0].AirportNameVia || flight[1].AirportNameVia;
        inserts[indexes.InboundChangeover].innerHTML = 'Change at ' + via + ' Airport';
      }
      control.classList.remove('hidden');
    } else {
      let control = document.querySelector('[data-basket-element="InboundChangeover"]');
      control.classList.add('hidden');
    }
  }

  // Content is updated in Basket, invalidate ViewManager will cause mini-sticky-basket to get updates
  ViewManager.invalidate();
}

export function initTransfers(transfer) {
  let control = document.querySelector('[data-basket-element="transfers"]');
  let insert = document.querySelector('[data-insert="SelectedTransfer"]');
  // case if no transfer available
  if (sessionStorage.getItem('transfersShouldBeHidden') === "true") {
    control.classList.add('hidden');
    insert.classList.add('hidden');
  } else if (!isNotNullOrWhitespace(transfer) || transfer === 'No Transfer') {
    insert.innerHTML = 'Your booking currently contains no transfers';
    control.classList.remove('hidden');
    insert.classList.remove('hidden');
  } else if (transfer !== 'No Transfer') {
    insert.innerHTML = transfer;
    control.classList.remove('hidden');
    insert.classList.remove('hidden');
  } else {
    control.classList.add('hidden');
    insert.classList.add('hidden');
  }

  // Content is updated in Basket, invalidate ViewManager will cause mini-sticky-basket to get updates
  ViewManager.invalidate();
}

export function initIncludes(includes) {
  let control = document.querySelector('[data-basket-element="includes"]');
  let list = document.querySelector('[data-insert="includes"]');
  let includesHTML = '<ul class="list-bullet">';

  if (isNotNullOrEmptyArray(includes)) {
    control.classList.remove('hidden');
    for (let i = 0; i < includes.length; i++) {
      let comment = includes[i].Comment ? `<i class="booking-tooltip" data-basket-tooltip title="${includes[i].Comment}">i</i>` : '';
      includesHTML += `<li>${includes[i].Name} ${comment}</li>`;
    }
    includesHTML += '</ul>';
    list.innerHTML = includesHTML;
  } else {
    control.classList.add('hidden');
    list.classList.add('hidden');
    list.innerHTML = '';
  }

  // Content is updated in Basket, invalidate ViewManager will cause mini-sticky-basket to get updates
  ViewManager.invalidate();
}

export function initExtras(extras) {
  let control = document.querySelector('[data-basket-element="extras"]');
  let list = document.querySelector('[data-insert="extras"]');
  if (isNotNullOrEmptyArray(extras)) {
    control.classList.remove('hidden');
    let extrasHTML = '';
    for (let i = 0; i < extras.length; i++) {
      extrasHTML = extrasHTML + '<p>' + extras[i] + '</p>';
    }
    list.innerHTML = extrasHTML;
  } else {
    control.classList.add('hidden');
    list.classList.add('hidden');
    list.innerHTML = '';
  }

  // Content is updated in Basket, invalidate ViewManager will cause mini-sticky-basket to get updates
  ViewManager.invalidate();
}

export function uuid() {
  if (localStorage.getItem('uuid') !== null) {
    if (localStorage.getItem('uuid') === '') {
      localStorage.removeItem('uuid');
      uuid();
    } 
    return localStorage.getItem('uuid');
  } else {
    let cryptoObj = window.crypto || window.msCrypto;
    let uuid = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
    localStorage.setItem('uuid', uuid);
    return uuid;
  }
}

export function cleanNumber(number) {
  number = parseFloat(number);
  if (number % 1 === 0) {
    number = Math.round(number);
  } else {
    number = number.toFixed(2);
  }
  return number;
}

export function getTotalNumberOfAvailableBags() {
  let totalNumberOfAvailableBags = 0;

  if (sessionStorage.basket) {
    const basketData = JSON.parse(sessionStorage.getItem('basket'));

    if (basketData.Passengers && basketData.Passengers.Passengers) {
      totalNumberOfAvailableBags = basketData.Passengers.Passengers.reduce((sum, passenger) => {
        if (passenger.PassengerTypeValue === "Adult" || passenger.PassengerTypeValue === "Child") {
          return sum += 1
        } else {
          return sum;
        }
      },0);

      return totalNumberOfAvailableBags;
    }
  }

  return 0;
}

export function getMinimumWeight() {
  if (sessionStorage.basket) {
    const basketData = JSON.parse(sessionStorage.getItem('basket'));

    if (basketData.Flights) {
      let weight = Infinity;

      basketData.Flights.forEach((flightData) => {
        let currentWeight = parseInt(flightData.LuggageAllowance)
        if (currentWeight !== NaN) {
          Math.min(currentWeight, weight);
        }
      });

      return weight === Infinity ? 0 : weight;
    }
  }

  return 0;
}
